type FullscreenListener = (activeElement: Element | null) => void;

const listeners = new Set<FullscreenListener>();
let subscribed = false;

const notify = () => {
  const active = document.fullscreenElement;
  listeners.forEach((listener) => listener(active));
};

const ensureSubscription = () => {
  if (subscribed) return;
  subscribed = true;
  document.addEventListener('fullscreenchange', notify);
};

export const subscribeDashboardWidgetFullscreen = (listener: FullscreenListener) => {
  ensureSubscription();
  listeners.add(listener);
  listener(document.fullscreenElement);
  return () => {
    listeners.delete(listener);
  };
};